import EventBus from "js-event-bus";

export const FORM_REMOVE_EVENT = "FORM_REMOVE_EVENT";

export const eventBus = new EventBus();
